import React from 'react';
import {
  List,
  Datagrid,
  TextField,
  BooleanField,
  EditButton,
  DeleteButton,
  CreateButton,
  TopToolbar,
  FilterButton,
  TextInput,
  BooleanInput,
  useRedirect,
} from 'react-admin';
import { CustomEmptyState } from '../../components/CustomEmptyState';

const ServiceProviderFilters = [
  <TextInput key="search" label="Search" source="q" alwaysOn />,
  <BooleanInput key="active" label="Active Only" source="active" defaultValue={true} />,
];

const ListActions = () => (
  <TopToolbar>
    <FilterButton />
    <CreateButton />
  </TopToolbar>
);

export const ServiceProviderList = () => {
  const redirect = useRedirect();

  const handleCreateServiceProvider = () => {
    redirect('/service-providers/create');
  };

  return (
    <List
      filters={ServiceProviderFilters}
      actions={<ListActions />}
      sort={{ field: 'name', order: 'ASC' }}
      empty={
        <CustomEmptyState resource="service-providers" onAction={handleCreateServiceProvider} />
      }
    >
      <Datagrid rowClick="show">
        <TextField source="name" />
        <TextField source="address" />
        <TextField source="city" />
        <TextField source="provinceState" label="Province/State" />
        <TextField source="country" />
        <TextField source="phoneNumber" label="Phone" />
        <BooleanField source="active" />
        <EditButton />
        <DeleteButton />
      </Datagrid>
    </List>
  );
};
